import { useEffect, useState } from 'react';
import { getTeachers } from '../services/teacherService';
import Swal from 'sweetalert2';
import { message } from 'antd';
import { useTranslation } from 'react-i18next';

const useFetchTeachers = () => {
  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { t } = useTranslation();


  useEffect(() => {
    const fetchTeachers = async () => {
      try {
        const response = await getTeachers({page:1 , limit:10000});
        setTeachers(response.data);
      } catch (error) {
        setError("Failed to fetch teachers");
        message.error(t("failed_to_load_teachers"));
      } finally {
        setLoading(false);
      }
    };

    fetchTeachers();
  }, []);

  return { teachers, loading, error };
};

export default useFetchTeachers;
